// not supported on web
export default ({ children }) => children;



// WEBPACK FOOTER //
// ./src/music/Player/index.web.js